import { render, staticRenderFns } from "./SkeletonCardVideo.vue?vue&type=template&id=f914fe68&scoped=true"
import script from "./SkeletonCardVideo.vue?vue&type=script&lang=js"
export * from "./SkeletonCardVideo.vue?vue&type=script&lang=js"
import style0 from "./SkeletonCardVideo.vue?vue&type=style&index=0&id=f914fe68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f914fe68",
  null
  
)

export default component.exports